import { render, staticRenderFns } from "./ChooseBizUnitDialog.vue?vue&type=template&id=322551aa&scoped=true"
import script from "./ChooseBizUnitDialog.vue?vue&type=script&lang=js"
export * from "./ChooseBizUnitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322551aa",
  null
  
)

export default component.exports